var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import Image from './Image';
import Video from './Video';
const Media = (_a) => {
    var { media, className = '', onClick = () => { }, // eslint-disable-line
    stepIndex, displaySkeleton = false, gradientOverlay = false } = _a, props = __rest(_a, ["media", "className", "onClick", "stepIndex", "displaySkeleton", "gradientOverlay"]);
    if (!media) {
        return React.createElement(Image, Object.assign({ image: null }, props));
    }
    if (media.__typename === 'ImageType' || media.__typename === 'ImageVariant') {
        return (React.createElement(Image, Object.assign({ stepIndex: stepIndex, onClick: onClick, className: className, image: media, gradientOverlay: gradientOverlay, displaySkeleton: displaySkeleton }, props)));
    }
    if (media.__typename === 'Video') {
        return React.createElement(Video, Object.assign({ className: className, video: media }, props));
    }
    return null;
};
export default Media;
